<template>
  <div class="action">
    <!--button @click="isOpen = !isOpen" class="button is-primary" slot="botton">
      Update User
    </button-->
    <div :class="['modal', { 'is-active': isOpen }]">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Update Form Status</p>
          <button @click="cancel" class="delete" aria-label="close"></button>
        </header>
        <section class="modal-card-body">
          <form>
            <div class="columns">
              <div class="column">
                                    <!-- <div class="field">
                      <label class="modal-card-title">Verification Token</label>
                      <input
                        v-model="form.verification_token"
                        @blur="$v.form.verification_token.$touch"
                        type="text"
                        class="input"
                        placeholder="Enter Verification Token"
                      />
                </div>
                <div class="field">
                      <label class="modal-card-title">Verified By</label>
                      <input
                        v-model="form.verifiedBy"
                        @blur="$v.form.verifiedBy.$touch"
                        type="text"
                        class="input"
                        placeholder="Verified By"
                      />
                </div> -->
                <div class="field">
                    <label class="modal-card-title">Form Status</label><p>
                     <input class="radio" type="radio" v-model="form.form_status" @blur="$v.form.form_status.$touch" value="Unverified">Unverified
                    <span style="margin-right:40px;"></span>
                    <input class="radio" type="radio" v-model="form.form_status" @blur="$v.form.form_status.$touch" value="Pending">Pending
            </p>
                </div>
                <!-- <div class="field">
              <label class="modal-card-title">Question</label>
              <textarea v-model="form.question" class="textarea" placeholder="Enter question here..." />
            </div> -->
              <!-- <div class="field">
              <label class="modal-card-title m-b-sm">Please Choose User Role</label>
              <div class="control">
                <div class="select is-primary">
                  <select v-model="form.isVerified">
                    <option>Yes</option>
                    <option>No</option>
                  </select>
                </div>
               
            </div>
                </div> -->
              </div>
            </div>
          </form>
        </section>
        <footer class="modal-card-foot">
          <button
            @click="updateCitizenStatusPressed"
            :disabled="isFormInvalid || this.oneOfCodes"
            class="button is-success"
          >
            Save changes
          </button>
          <button @click="cancel" class="button">Cancel</button>
        </footer>
      </div>
    </div>
  </div>
</template>



<script>
import axiosInstance from '../../services/axios';
import axios from 'axios';
import { getAPIEndpoint } from '../../helpers';
import { required, minLength, url, sameAs } from 'vuelidate/lib/validators';
export default {
  // props: {
  //   dataUrl: {
  //     type: String,
  //     default: null,
  //   },
  //   checkable: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  data() {
    return {
      name: '',
      slug: '',
      quantity: 0,
      // isOpen: false,
      isCategoryLoading: false,
      form: {
        // verification_token: this.selectedCitizen.verification_token,
        // verifiedBy: this.selectedCitizen.verifiedBy,
        form_status: this.selectedCitizen.form_status,
        // isVerified: this.selectedCitizen.isVerified,
        _id: this.selectedCitizen._id,
        code_no: this.$store.state.auth.user.code_no,
        office_code_no: this.$store.state.auth.user.office_code_no,
        last_modified_by: this.$store.state.auth.user.name,
        last_modified: new Date(),
      },
      uploadPercent: 0,
      file: null,
    };
  },
  validations: {
    form: {
        form_status:{
            required
        },
        code_no:{
          // required
        }, 
        office_code_no:{
          // required
        },
      // verification_token: {
      //   required,
      // },
      // verifiedBy: {
      //   required
      // }
      // isVerified: {
      //   required,
      // },
      // startDate: {
      //   required,
      // },
      // endDate: {
      //   required,
      // },
      // subjects: {
      //   required,
      // },
      last_modified_by: {
        required
      },
      last_modified: {
        required
      }
    },
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    selectedCitizen: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isFormInvalid() {
      return this.$v.form.$invalid;
    },
    buttonLabel() {
      return !this.file ? 'Pick a file' : 'Pick another file';
    },
    citizens() {
      return this.$store.state.citizens.items;
    },
    oneOfCodes(){
    if( (this.form.code_no !== '' ) || 
        (this.form.office_code_no !== '' )){
          return false;
        }
        else{
          return true;
        }
  }
  },

  mounted() {},
  created() {
     this.name = this.$store.state.auth.user.name;
  },
  methods: {
    updateCitizenStatusPressed() {
      // console.log(this.form);
      // console.log(this.form.verifiedBy)
      // this.$v.form.$touch();

      if(this.form.form_status == 'Unverified'){
        this.form.code_no = '';
        this.form.office_code_no = '';
      }


      this.$store
        .dispatch('citizens/updateCitizenWithId', this.form)
        .then(() => {
          this.isOpen = false;

          // this.form = {};
          this.uploadPercent = 0;

          this.$buefy.snackbar.open({
            message: 'User Verified Successfully',
            queue: false,
          });
        })
        .catch((err) => {
          this.$buefy.snackbar.open({
            message: `${err.response.data.message}`,
            queue: false,
          });
        });
    },
        cancel() {
      this.$emit('cancel');
    },
  },
};
</script>


<style scoped>
.modal-card {
  width: 60%;
}

.container {
  width: 50px;
  margin: 0 80%;
}

.level .img {
  right: -112px;
  position: absolute;
  border-radius: 30px;
}
</style>


